import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import CommissionTotalsItem from './CommissionTotalsItem';
import WalletProp from '../../proptype/walletProp';

const CommissionCryptoTotals = props => {
  const { t, totals, activeWallet } = props;

  const cryptoCurrency =
    activeWallet?.currencyInfo?.symbol_native ||
    activeWallet?.currencyInfo?.symbol;
  const formatMoney = value => `${value || 0}${cryptoCurrency}`;

  const { userSales = 0, userCommission = 0 } = totals;

  // Block Values with Sponsor
  const personalSales = formatMoney(userSales);
  const personalCommission = formatMoney(userCommission);

  const personalSalesDescription = t(
    'commissions.personalSales.without.VAIntegration',
  );
  const personalCommissionsDescription = t(
    'commissions.personalCommission.without.VAIntegration',
  );

  return (
    <div className="commission-totals-wrapper">
      <div
        className="grid-row"
        style={{ gridTemplateColumns: 'repeat(2, 1fr)' }}
      >
        <div className="grid-item">
          <CommissionTotalsItem
            title={t('commissions.personalSales')}
            description={personalSalesDescription}
            value={personalSales}
          />
        </div>
        <div className="grid-item">
          <CommissionTotalsItem
            title={t('commissions.personalCommission')}
            description={personalCommissionsDescription}
            value={personalCommission}
          />
        </div>
      </div>
    </div>
  );
};

CommissionCryptoTotals.propTypes = {
  t: PropTypes.func.isRequired,
  totals: PropTypes.shape({
    userVA: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    groupVA: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    VALeft: PropTypes.number,
    VARight: PropTypes.number,
    remainingBinaryVA: PropTypes.number,
    userSales: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    teamSales: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    teamCommission: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    userCommission: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    totalCommissions: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    groupCommissions: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    forecastDate: PropTypes.number,
  }),
  activeWallet: PropTypes.shape(WalletProp.propType),
};
CommissionCryptoTotals.defaultProps = {
  totals: {},
  activeWallet: null,
};

export default translate(CommissionCryptoTotals);
